<!-- eslint-disable max-len -->
<template>
  <div>
    <div class="data-page-header">
      <div class="d-flex">
        <img
          class="back-to-list-apps"
          src="@/assets/icon/arrow-left.svg"
          @click="$router.push('/form-data')"
        >
        <h3 class="data-page-header-title ellipsis">{{ dataGroup ? dataGroup.name : 'Table Group Not Found' }}</h3>
      </div>
      <div class="d-flex">
        <b-form-input
          ref="filterInput"
          v-model="filter_data"
          placeholder="Search Table"
          class="text-search-data"/>
        <i
          v-show="!viewOnly || isAdmin"
          id="addPopover"
          class="fa fa-lg fa-plus font-weight-bold cursor-pointer m__t--10 m__l--10"/>
      </div>
      <div class="action-select-data">
        <span
          v-show="showCheckboxExportTable"
          @click="selectAll">Select All</span>
        <span
          v-show="showCheckboxExportTable"
          class="m__l--5"
          @click="unselectAll">Unselect All</span>
      </div>
    </div>
    <div
      v-if="modeDetail"
      class="data-page-header-full" />

    <div class="data-left-content">
      <div
        v-for="(item, index) in formList"
        :key="item.id"
        :class="{ 'active': form_id === item.id }"
        class="list-data-content">
        <j-checkbox
          v-show="showCheckboxExportTable"
          :checked="checkSelected(item.id)"
          class="checkbox-oos tick-import-data"
          @input="selectData($event, item)"
        />
        <div
          class="item-data-manager"
          @click="switchForm(item), setActive(index)">
          <img
            :src="require('@/assets/logo/icon-table.svg')"
            class="m__r--10"
            height="19">
          <div class="info__list-data-content">
            <div class="title__list-data-content">{{ item.name ? item.name : 'No Name' }}</div>
            <div class="id__list-data-content">{{ item.id }}</div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="modeDetail"
      class="data-right-update-content">
      <j-form-page-detail
        :form-id="form_id"
        :form-name="form_name"
        :key="form_id"
        :switcher="nocode_switcher"
      />
    </div>
    <div
      v-else
      class="data-right-create-content">
      <div class="table-data-manager-logo">
        <img
          src="@/assets/logo/data-manager.svg"
          height="100">
        <div class="m__t--10">No Table Selected</div>
      </div>
      <div
        v-show="showBtnAddTable"
        class="table-data-manager-btn"
        @click="addFormData">
        Create Table
      </div>
    </div>

    <b-modal
      ref="appTypeFormDataModal"
      class="mod-form modal-type-form-data"
      centered
      no-close-on-esc
      no-close-on-backdrop>
      <div class="label-group-modal text-center">CREATE TABLE</div>
      <div class="container-type-list-options">
        <div
          :class="typeMode === 'blank' ? 'option-active' : ''"
          class="container-option"
          @click="selectMode('blank')">
          <img
            v-if="typeMode === 'blank'"
            src="@/assets/icon/blank-blue.png">
          <img
            v-else
            src="@/assets/icon/blank.png">
          <span class="text-option">Create New Blank</span>
        </div>
        <div
          :class="typeMode === 'code' ? 'option-active' : ''"
          class="container-option"
          @click="selectMode('code')">
          <img
            v-if="typeMode === 'code'"
            src="@/assets/icon/code-blue.png">
          <img
            v-else
            src="@/assets/icon/code.png">
          <span class="text-option">Execute Code</span>
        </div>
      </div>
      <b-row>
        <b-col>
          <div class="float-to-right">
            <b-button
              class="btn white m__r--5"
              @click="closeTypeForm">
              Close
            </b-button>
            <b-button
              class="btn blue"
              @click="nextStep">
              Next
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      ref="appCodeFormDataModal"
      class="mod-form modal-code-form-data"
      centered
      no-close-on-esc
      no-close-on-backdrop>
      <div class="label-group-modal text-center">CREATE TABLE</div>
      <label> JSON </label>
      <j-monaco-editor
        v-if="showCodeEditor"
        ref="scriptEditor"
        :value="jsonData"
        language="json"
      />
      <br>
      <b-row>
        <b-col>
          <div class="float-to-right">
            <b-button
              class="btn white m__r--5"
              @click="closeCodeForm">
              Close
            </b-button>
            <b-button
              class="btn blue"
              @click="createCodeData">
              Next
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      ref="appAddFormDataModal"
      class="mod-form modal-form-ui"
      centered
      no-close-on-esc
      no-close-on-backdrop>
      <div class="label-group-modal text-center">CREATE TABLE</div>
      <b-form-group :class="{'error-input' : $v.form_data.name.$error}">
        <label> Name </label>
        <j-input
          v-model="$v.form_data.name.$model"
          :error-required="$v.form_data.name.$error"
          :max-length="255"
          placeholder="Only lowercase characters and underscore '_' are allowed, ex: name_table"/>
      </b-form-group>
      <!-- <b-form-group :class="{'error-input' : $v.form_data.type.$error}">
        <label> Type </label>
        <j-single-select
          v-model="$v.form_data.type.$model"
          :options="list_type"
          :placeholder="'Select Type'"
          label="name"/>
      </b-form-group> -->
      <b-form-group :class="{'error-input' : $v.form_data.is_offline_mode.$error}">
        <label> Local Storage Support (Offline Mode) </label>
        <j-toggle v-model="form_data.is_offline_mode"/>
      </b-form-group>
      <br>
      <b-row>
        <b-col>
          <div class="float-to-right">
            <b-button
              class="btn white m__r--5"
              @click="closeCreateForm">
              Close
            </b-button>
            <b-button
              class="btn blue"
              @click="createFormData">
              Next
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      ref="appImportFormDataModal"
      class="mod-form modal-add-form-data"
      centered
      no-close-on-esc
      no-close-on-backdrop>
      <div class="label-group-modal text-center">IMPORT</div>
      <div
        v-if="dropboxImportShow"
        class="dropbox-oos">
        <input
          type="file"
          multiple
          class="input-file"
          @change="handleFileUpload($event.target.files)">
        <img :src="require('@/assets/form-data/file-dropbox.png')">
        <div class="label-dropbox">Drop your file here, or <span>browse</span></div>
        <div class="label-support-dropbox">Support : JSON</div>
      </div>
      <b-row>
        <b-col>
          <div class="float-to-right">
            <b-button
              class="btn white"
              @click="closeImportForm">
              Close
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <div
      :class="{'show-container-floating-data-manager' : showProperties,
               'hide-container-floating-data-manager' : !showProperties,
               'container-floating-data-manager-long' : !is_sidebar_minimized}"
      class="container-floating-data-manager table">
      <div class="count-data-selected table">{{ selected_rows.length }}</div>
      <div class="label-data-selected table">Selected <br> Table{{ selected_rows.length > 1 ? 's' : '' }}</div>
      <div
        v-show="showBtnMoveTable"
        class="btn-move-table"
        @click="openPropMoveTable">
        <img :src="require('@/assets/icon/move-table.svg')"> Move Table Group
      </div>
      <div
        v-show="showBtnExportTable"
        class="btn-export-data table"
        @click="exportData">
        <img :src="require('@/assets/icon/export-data-white.svg')"> Export
      </div>
      <div
        class="close-data-selected"
        @click="unselectAll">X</div>
    </div>

    <b-popover
      v-click-outside="closePopover"
      ref="addPopoverRef"
      :show.sync="addPopoverShow"
      target="addPopover"
      placement="bottom">
      <div
        :class="{ 'disabled': !showBtnAddTable}"
        class="add-data-manager"
        @click="createNewBlank">
        <div class="w__10"><img :src="require('@/assets/form-data/new-blank-small.png')"></div>
        <div class="m__l--10">Create New Blank</div>
      </div>
      <div
        :class="{ 'disabled': !showBtnAddTable}"
        class="add-data-manager"
        @click="executeCode">
        <div class="w__10"><img :src="require('@/assets/form-data/execute-code-small.png')"></div>
        <div class="m__l--10">Execute Code</div>
      </div>
      <div
        :class="{ 'disabled': !showBtnImportTable}"
        class="add-data-manager"
        @click="importTable">
        <div class="w__10"><img :src="require('@/assets/form-data/import-small.png')"></div>
        <div class="m__l--10">Import</div>
      </div>
    </b-popover>

    <!-- Block Properties ---------------------------------------------------------------------- -->
    <div
      :class="{'show-container-properties-automation' : showPropertiesMove, 'hide-container-properties-automation' : !showPropertiesMove}"
      class="container-properties-automation">
      <div class="d-flex align-items-start justify-content-between">
        <div class="label-log-detail">Move Table Group</div>

        <div class="d-flex align-items-center">
          <div
            class="close-properties-automation"
            @click="hidePropertiesMove">
            <img
              :src="require('@/assets/icon/icon-close-properties.svg')"
              width="25">
          </div>
        </div>
      </div>

      <div class="container-move-table-data-manager">
        <div class="m__t--10">Selected Table{{ selected_rows.length > 1 ? 's' : '' }}</div>
        <div class="count-data-selected">{{ selected_rows.length }}</div>
      </div><hr>

      <b>Move table{{ selected_rows.length > 1 ? 's' : '' }} to another table group</b>

      <b-form-group :class="{'error-input' : $v.tableGroup.$error}">
        <label> Table Group </label>
        <j-single-select
          v-model="$v.tableGroup.$model"
          :options="tableGroupOptions"
          placeholder="Select Table Group"
          value-format="object"
          label="name"/>
      </b-form-group>

      <div class="information-move-table">
        <img
          :src="require('@/assets/icon/warning.png')"
          class="m__r--5"
          height="15"
          width="15">
        <div>
          <div class="label-info">Information</div>
          <div>Before moving the table, make sure your selection. Once moved, you can no longer move the table to another table group</div>
        </div>
      </div>

      <div
        :class="{'show-privilege-data-manager-access-button' : showPropertiesMove, 'hide-privilege-data-manager-access-button' : !showPropertiesMove}"
        class="privilege-data-manager-access-button">
        <button
          class="button-border close-prop-2"
          @click="hidePropertiesMove">
          Close
        </button>
        <button
          class="button-border submit-prop"
          @click="assignDataGroupTable">
          Move Table
        </button>
      </div>
    </div>

    <j-progress
      ref="progressMoveTable"
      :data-kirim="data_selected"
      :url-api="url_move_group"
      :headers="headers"
      @finish="finishActionMove"/>
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies, no-nested-ternary, max-len, no-unused-vars, no-console */
import { mapActions, mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import jFormPageDetail from '@/views/data-manager/jFormPageDetail';
import jProgress from '@/components/progress-screen/jProgress';
import ClickOutside from 'vue-click-outside';
import jwtDecode from 'jwt-decode';
import axios from 'axios';
import Vue from 'vue';

import jMonacoEditor from '@/components/monaco-editor/jMonacoEditor';

export default {
  /* eslint-disable vue/name-property-casing */
  name: 'jForm',
  components: {
    jFormPageDetail,
    jProgress,
    jMonacoEditor,
  },
  directives: {
    ClickOutside,
  },
  data() {
    return {
      jsonData: '',
      darkMode: false,
      filter_data: '',
      pageNumber: 1,
      isLoadingForms: true,
      isLoadingSearch: false,
      isNextPage: false,
      select_type: 'id',
      options_search: [
        {
          text: 'ID',
          value: 'id',
        },
      ],
      modeDetail: false,
      form_data: {
        name: '',
        type: 'transaction',
        is_offline_mode: false,
      },
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
      typeMode: '',
      formList: [],
      list_type: [
        { id: 'transaction', name: 'transaction' },
        { id: 'dataset', name: 'dataset' },
      ],
      selected_rows: [],
      addPopoverShow: false,
      dropboxImportShow: false,
      file: null,
      dataGroup: null,
      showPropertiesMove: false,
      tableGroupOptions: [],
      tableGroup: null,
      data_selected: [],
      url_move_group: '/nocode/data/tablegroup/assign',
      enable_move_table: false,
      showCodeEditor: false,
      nocode_switcher: false,
    };
  },
  computed: {
    ...mapState('jStoreForm', ['form_list', 'form_id', 'form_name', 'form_length', 'form_index', 'form_changed',
      'table_by_group_list', 'privilege_by_me']),
    ...mapState('jStoreSetting', ['is_sidebar_minimized']),

    showProperties() {
      return this.selected_rows.length > 0;
    },

    headers() {
      const token = Vue.ls.get('Token');
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      return headers;
    },

    isAdmin() {
      const role = localStorage.getItem('userRole');
      return Number(role) === 1;
    },

    showBtnMoveTable() {
      return this.isAdmin && (this.$route.params.id === 'legacy' || this.enable_move_table);
    },

    showBtnAddTable() {
      return (this.isAdmin || (this.privilege_by_me.includes('create_table') && !this.privilege_by_me.includes('view_only'))) && this.$route.params.id !== 'legacy';
    },

    showBtnImportTable() {
      return (this.isAdmin || this.privilege_by_me.includes('create_table')) && this.$route.params.id !== 'legacy';
    },

    showBtnExportTable() {
      return this.isAdmin || this.privilege_by_me.includes('create_table');
    },

    showCheckboxExportTable() {
      return this.isAdmin || (this.privilege_by_me.includes('create_table') && !this.privilege_by_me.includes('view_only'));
    },

    viewOnly() {
      return this.privilege_by_me.includes('view_only');
    },
  },
  watch: {
    form_list(val) {
      // this.formList = [...val];
    },

    table_by_group_list(val) {
      this.formList = [...val];
      if (this.$route.params.idTable) {
        const findData = val.find(f => f.id === this.$route.params.idTable);
        if (findData) this.switchForm(findData);
      }
    },

    // eslint-disable-next-line
    'form_data.name': function (val){
      const regexSymbol = /[^\w\s]/g;
      setTimeout(() => {
        this.form_data.name =
          val.toLowerCase()
            .replace(regexSymbol, '')
            .replace(' ', '_');
      }, 1);
    },

    // eslint-disable-next-line
    'form_length': function (val){
      if (val / this.pageNumber > 10) {
        this.isNextPage = true;
      } else {
        this.isNextPage = false;
      }
    },

    form_changed() {
      this.modeDetail = false;
    },

    filter_data(val) {
      // this.formList = this.form_list.filter(app => app.name.toUpperCase().includes(val.toUpperCase()) || app.id.toUpperCase().includes(val.toUpperCase()));
      this.formList = this.table_by_group_list.filter(app => app.name.toUpperCase().includes(val.toUpperCase()) || app.id.toUpperCase().includes(val.toUpperCase()));
    },

    selected_rows(val) {
      if (val && val.length === 0) {
        this.hidePropertiesMove();
      }
    },
  },
  created() {
    this.getDataGroup();
    this.getPrivilegeByMe();
    this.getDataSettings();
  },
  mounted() {
    this.$refs.filterInput.focus();
  },
  methods: {
    ...mapActions('jStoreForm', ['actionSetFormData', 'actionSetForm', 'actionSetNameForm', 'actionSetFormIndex', 'createForm',
      'getListDataGroup', 'getListTableByGroup', 'createTable', 'assignDataGroup', 'getListPrivilegeByMe']),
    ...mapActions('jStoreSetting', ['actionGetUserCompanySettingV2']),
    ...mapActions('jStoreNotificationScreen', ['toggleInfo', 'toggleProblem']),

    getDataGroup() {
      const req = {
        page: 1,
        limit: 1000000,
        sort: { updated_at: -1 },
        search: '',
      };
      this.getListDataGroup(req).then((res) => {
        if (!res.error) {
          const detailGroup = res.data.find(f => f.id === this.$route.params.id);
          this.dataGroup = detailGroup || null;
          this.tableGroupOptions = res.data.filter(f => f.id !== 'legacy');
          this.getTableList('');
        }
      });
    },

    getTableList(search) {
      if (this.dataGroup) {
        const reqTable = {
          tablegroup_id: this.dataGroup.id,
          search,
        };
        this.getListTableByGroup(reqTable);
      }
    },

    getPrivilegeByMe() {
      this.getListPrivilegeByMe({ tablegroup_id: this.$route.params.id });
    },

    async getDataSettings() {
      const { data, error } = await this.actionGetUserCompanySettingV2(false);
      if (!error) {
        this.enable_move_table = data.data_manager_enable_move_table || false;
        this.nocode_switcher = data.nocode_switcher || false;
      }
    },

    selectData(data, item) {
      const exsist = this.selected_rows.find(f => f.id === item.id);
      if (exsist) {
        const indexDeleted = this.selected_rows.findIndex(e => e.id === item.id);
        this.selected_rows.splice(indexDeleted, 1);
      } else {
        this.selected_rows.push(item);
      }
    },

    selectAll() {
      this.selected_rows = [...this.formList];
    },

    unselectAll() {
      this.selected_rows = [];
    },

    checkSelected(id) {
      const findID = this.selected_rows.find(f => f.id === id);
      return !!findID;
    },

    exportData() {
      this.$store.dispatch('jStoreNotificationScreen/showLoading', 'Please wait');
      const token = Vue.ls.get('Token');
      const gateUrl = localStorage.getItem('gateUrl');
      const url = `${gateUrl}nocode/data/export-v2`;
      const params = {
        id: this.selected_rows.map(val => val.id),
      };

      axios.post(url, params, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }).then((res) => {
        this.$store.dispatch('jStoreNotificationScreen/hideLoading', '');
        const data = JSON.stringify(res.data);
        const blob = new Blob([data], { type: 'text/plain' });
        const e = document.createEvent('MouseEvents');
        const a = document.createElement('a');
        a.download = 'data-manager.json';
        a.href = window.URL.createObjectURL(blob);
        a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
        e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
        a.dispatchEvent(e);
      });
    },

    handleFileUpload(file) {
      if (file[0].type.includes('json')) {
        this.$swal({
          title: 'IMPORT',
          text: `Are you sure to import file ${file[0].name} ?`,
          showCancelButton: true,
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes',
        }).then(async (result) => {
          if (result.value) {
            this.$store.dispatch('jStoreNotificationScreen/showLoading', 'Please wait');
            const token = Vue.ls.get('Token');
            const formData = new FormData();
            const gateUrl = localStorage.getItem('gateUrl');
            const url = `${gateUrl}nocode/data/import-v2?token=${token}`;

            formData.append('file', file[0]);
            formData.append('tablegroup_id', this.dataGroup.id);

            axios.post(url, formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${token}`,
              },
            },
            ).then(() => {
              this.$store.dispatch('jStoreNotificationScreen/hideLoading', '');
              this.$store.dispatch('jStoreNotificationScreen/toggleSuccess', 'Success Import Data');
              this.closeImportForm();
              setTimeout(() => {
                this.getTableList('');
              }, 500);
            }).catch(() => {
              this.$store.dispatch('jStoreNotificationScreen/hideLoading', '');
              this.$store.dispatch('jStoreNotificationScreen/toggleProblem', 'Error Import Data');
            });
          } else {
            this.dropboxImportShow = false;
            setTimeout(() => {
              this.dropboxImportShow = true;
            }, 100);
          }
        });
      } else {
        this.$store.dispatch('jStoreNotificationScreen/toggleProblem', 'File not support');
      }
    },

    closeImportForm() {
      this.$refs.appImportFormDataModal.hide();
      this.dropboxImportShow = false;
    },

    selectMode(val) {
      this.typeMode = val;
    },

    setActive(index) {
      this.actionSetFormIndex(index);
    },

    updateNextPage() {
      if (this.form_length / this.pageNumber > 5) {
        this.isNextPage = true;
      } else {
        this.isNextPage = false;
      }
    },

    switchForm(data) {
      this.modeDetail = true;
      this.actionSetFormData(data);
      this.actionSetForm(data.id);
      this.actionSetNameForm(data.name || 'No Name');
      if (this.$route.params.idTable !== data.id) {
        this.$router.push(`/form-data/table/${this.$route.params.id}/${data.id}`);
      }
    },

    addFormData() {
      this.$refs.appTypeFormDataModal.show();
    },

    nextStep() {
      if (this.typeMode === 'blank') {
        this.$refs.appAddFormDataModal.show();
      } else {
        this.$refs.appCodeFormDataModal.show();
        setTimeout(() => { this.showCodeEditor = true; }, 500);
      }
    },

    closeTypeForm() {
      this.$refs.appTypeFormDataModal.hide();
    },

    createCodeData() {
      const json = typeof this.$refs.scriptEditor !== 'undefined' ? this.$refs.scriptEditor.getData().trim() : '';
      if (json) {
        const param = JSON.parse(json);
        param.tablegroup_id = this.dataGroup.id;
        // delete param.columns;
        this.createTable(param).then((response) => {
          if (!response.error && response.error_session) {
            this.toggleInfo(response.message);
          } else if (!response.error && !response.error_session) {
            this.jsonData = '';
            this.showCodeEditor = false;
            this.$refs.appCodeFormDataModal.hide();
            this.switchForm(response.data);
          } else {
            this.toggleProblem(response.message);
          }
        });
      }
    },

    closeCodeForm() {
      this.jsonData = '';
      this.showCodeEditor = false;
      this.$refs.appCodeFormDataModal.hide();
    },

    closeCreateForm() {
      this.form_data.name = '';
      this.form_data.type = 'transaction';
      this.form_data.is_offline_mode = false;
      this.$refs.appAddFormDataModal.hide();
      setTimeout(() => {
        this.$v.form_data.$reset();
      }, 500);
    },

    validateData() {
      this.$v.form_data.$touch();
      return this.$v.form_data.$error;
    },

    createFormData() {
      if (!this.validateData()) {
        // eslint-disable-next-line
        const text = `Local Storage Support can’t be updated after the table has successfully created`;
        const textMode = this.form_data.is_offline_mode ? 'with' : 'without';
        this.$swal({
          title: `Are you sure to create table ${textMode} Local Storage Support ?`,
          text,
          showCancelButton: true,
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes',
        }).then(async (result) => {
          if (result.value) {
            const param = {
              tablegroup_id: this.dataGroup.id,
              name: this.form_data.name,
              type: this.form_data.type,
              is_offline_mode: this.form_data.is_offline_mode,
            };
            this.createTable(param).then((response) => {
              if (!response.error && response.error_session) {
                this.toggleInfo(response.message);
              } else if (!response.error && !response.error_session) {
                this.switchForm(response.data);
              } else {
                this.toggleProblem(response.message);
              }
            });

            this.form_data.name = '';
            this.form_data.type = 'transaction';
            this.form_data.is_offline_mode = false;
            this.$refs.appAddFormDataModal.hide();
          }
        });
      }
    },

    openPropMoveTable() {
      this.showPropertiesMove = true;
    },

    assignDataGroupTable() {
      this.$v.tableGroup.$touch();
      if (!this.$v.tableGroup.$error) {
        this.data_selected = this.selected_rows.map(val => ({
          tablegroup_id: this.tableGroup.id,
          formdata_id: val.id,
        }));
        setTimeout(() => {
          this.$refs.progressMoveTable.toggleIsVisible();
        }, 500);
      }
    },

    hidePropertiesMove() {
      this.tableGroup = null;
      this.showPropertiesMove = false;
      setTimeout(() => { this.$v.tableGroup.$reset(); }, 100);
    },

    finishActionMove() {
      this.getTableList('');
      this.hidePropertiesMove();
      this.unselectAll();
    },

    createNewBlank() {
      if (this.showBtnAddTable) {
        this.$refs.appAddFormDataModal.show();
        this.addPopoverShow = false;
      }
    },

    executeCode() {
      if (this.showBtnAddTable) {
        this.$refs.appCodeFormDataModal.show();
        this.addPopoverShow = false;
        setTimeout(() => { this.showCodeEditor = true; }, 500);
      }
    },

    importTable() {
      if (this.showBtnImportTable) {
        this.$refs.appImportFormDataModal.show();
        this.addPopoverShow = false;
        this.dropboxImportShow = true;
      }
    },

    closePopover() {
      this.addPopoverShow = false;
    },
  },
  validations() {
    return {
      form_data: {
        name: {
          required,
        },
        type: {},
        is_offline_mode: {},
      },
      tableGroup: { required },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/data-manager/jForm.vue